// Frontend-only model branding. The engines are presented as our own in-house
// models; the backend routes on the real "glm-5.2" / "gpt-5.1" / "deepseek-v4-pro"
// values. To rebrand everywhere, change the constants below — single source of truth.
const NEOCORE_GLM = "NeoCore GLM"; // GLM-5.2 — default / recommended
const NEOCORE_AIR = "NeoCore Air"; // GPT-5.1 — alternate (hidden from Email/Cover Letter)
const NEOCORE_PRO = "NeoCore Pro"; // DeepSeek V4 Flash 0731 — fastest / cheapest, prompt-caching

export const MODEL_LABELS = {
  "z-ai/glm-5.2": NEOCORE_GLM,
  "glm-5.2": NEOCORE_GLM,
  "gpt-5.1": NEOCORE_AIR,
  // internal step models never expose a public vendor name
  "gpt-4.1-nano": NEOCORE_AIR,
  "gpt-5.4-mini": NEOCORE_AIR,
  "deepseek-v4-pro": NEOCORE_PRO,
  "deepseek/deepseek-v4-pro": NEOCORE_PRO,
  "deepseek/deepseek-v4-flash-0731": NEOCORE_PRO,
};

export const engineLabel = (m) => MODEL_LABELS[m] || m;

// The user-selectable engines + their admin lock-flag keys.
export const ENGINES = {
  "glm-5.2": {
    label: NEOCORE_GLM, badge: "Recommended", lockKey: "model_glm_locked",
    badgeClass: "bg-blue-100 text-blue-700 dark:bg-blue-950/40 dark:text-blue-400",
  },
  "deepseek-v4-pro": {
    label: NEOCORE_PRO, badge: "Fastest", tagline: "faster · low latency", lockKey: "model_deepseek_locked",
    badgeClass: "bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-400",
  },
  "gpt-5.1": {
    label: NEOCORE_AIR, badge: "Alternate", lockKey: "model_gpt_locked",
    badgeClass: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-400",
  },
};

// Which engines each surface offers.
export const ENGINE_KEYS_FULL = ["glm-5.2", "deepseek-v4-pro", "gpt-5.1"]; // Optimize + Extension
export const ENGINE_KEYS_LITE = ["glm-5.2", "deepseek-v4-pro"];            // Match Score, Email, Cover Letter (no Air)

export const MODEL_LOCK_MESSAGE = "The model is currently locked. Please use other model.";
